import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { CONTRACT_ALERT_CATEGORY_KEYS, DEFAULT_CONTRACT_ALERT_CATEGORY } from './-categories';
import { ContractAlertsPage } from './-ContractAlertsPage';
const AlertsSearchSchema = z.object({
  category: z.enum(CONTRACT_ALERT_CATEGORY_KEYS).default(DEFAULT_CONTRACT_ALERT_CATEGORY)
});
export const Route = createFileRoute('/_staff/contract/_list/_placeholders/alerts')({
  validateSearch: zodValidator(AlertsSearchSchema),
  component: ContractAlertsPage
});